module.exports = "https://cdn.realtymogul.com/static/media/RP_Villafrance.e82740d1.jpg";